export const yen = (value: number | null, compact = false): string => {
  if (value === null || Number.isNaN(value)) return "未入力";
  if (compact) {
    if (Math.abs(value) >= 100_000_000) return `${(value / 100_000_000).toFixed(2)}億円`;
    if (Math.abs(value) >= 10_000) return `${(value / 10_000).toFixed(0)}万円`;
  }
  return new Intl.NumberFormat("ja-JP", { style: "currency", currency: "JPY", maximumFractionDigits: 0 }).format(value);
};

export const percent = (value: number | null, digits = 1): string =>
  value === null || Number.isNaN(value)
    ? "未入力"
    : new Intl.NumberFormat("ja-JP", { style: "percent", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);

export const number = (value: number | null, digits = 1): string =>
  value === null || Number.isNaN(value)
    ? "未入力"
    : new Intl.NumberFormat("ja-JP", { maximumFractionDigits: digits }).format(value);

export const multiple = (value: number | null): string => value === null ? "未入力" : `${number(value, 2)}倍`;
export const days = (value: number | null): string => value === null ? "未入力" : `${number(value, 1)}日`;
export const months = (value: number | null): string => value === null ? "未入力" : `${number(value, 1)}か月`;

